import { render, staticRenderFns } from "./ColleaguesStep.vue?vue&type=template&id=0cf98220&scoped=true&"
import script from "./ColleaguesStep.vue?vue&type=script&lang=js&"
export * from "./ColleaguesStep.vue?vue&type=script&lang=js&"
import style0 from "./ColleaguesStep.vue?vue&type=style&index=0&id=0cf98220&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf98220",
  null
  
)

export default component.exports